export default __webpack_public_path__ + "static/media/29.a42fc789.jpg";